export const textDecorationKeys = ['textDecoration'];
